import {HttpClient} from '@angular/common/http';
import {AppletCatalogContainerModel} from '../../../../../models/aggregates/applet/applet-catalog-container.model';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {ApiVisa} from '../shared/api-visa.model';

@Injectable({providedIn: 'root'})
export class AppletCatalogService extends BaseApiTemplateService<AppletCatalogContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'applets-catalogs';
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'applets-catalogs';
    this.httpClient = http;
  }

  getAppletsByCatalogHeaderGuid(catalogHdrGuid: string, apiVisa: ApiVisa) {
    const url = this.apiUrl + '/query?catalog_hdr_guid=' + catalogHdrGuid;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }
}
